import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common/PageHeader";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";
import RecruitingDashboard from "@/pages/recruiting/RecruitingDashboard";
import { AddLeadDialog } from "@/components/recruiting/AddLeadDialog";
import { NewLeadsShortcut } from "@/pages/recruiting/NewLeads";

const FILTER_KEYS = ["status", "candidate_type", "recruiter_id", "organization_id", "source", "pipeline_id", "stage_id"];

export default function MyDashboard() {
  const { user, isOutside } = useAuth();
  const navigate = useNavigate();
  const [leadOpen, setLeadOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  if (isOutside) return <Navigate to="/" replace />;
  const first = (user?.name || "").trim().split(" ")[0] || "there";

  // Personal drill-through always lands on the recruiter's own candidates.
  const onDrill = (nav) => {
    const p = new URLSearchParams();
    p.set("tab", "mine");
    FILTER_KEYS.forEach((k) => { if (nav[k]) p.set(k, nav[k]); });
    navigate(`/recruiting?${p.toString()}`);
  };

  return (
    <div data-testid="my-dashboard-page">
      <PageHeader
        title={`Welcome back, ${first}`}
        description="Your personal recruiting productivity — candidates you own, your pipeline, and what needs your attention today."
        actions={<Button className="bg-brand hover:bg-brand-strong text-white" onClick={() => setLeadOpen(true)} data-testid="my-dashboard-add-lead"><UserPlus className="w-4 h-4 mr-1.5" />Add Lead</Button>}
      />
      <AddLeadDialog open={leadOpen} onClose={() => setLeadOpen(false)} onCreated={() => { setLeadOpen(false); setRefreshKey((k) => k + 1); }} />
      {!isOutside && <NewLeadsShortcut />}
      <RecruitingDashboard key={refreshKey} personal onDrill={onDrill} />
    </div>
  );
}
